module.exports = __webpack_public_path__ + "static/media/rm_06-09.812bd56d.png";